import dynamic from 'next/dynamic';
import { CSSProperties, memo } from 'react';
const ICON_MAP = {
  AddStoryFill: 'add-story-fill',
  AddStory: 'add-story',
  AlarmClockFill: 'alarm-clock-fill',
  AlarmClock: 'alarm-clock',
  ArrowCapsulepath: 'arrow-capsulepath',
  ArrowCirclepath: 'arrow-circlepath',
  ArrowDownLeftFill: 'arrow-down-left-fill',
  ArrowDownLeft: 'arrow-down-left',
  ArrowDownLine: 'arrow-down-line',
  ArrowDown: 'arrow-down',
  ArrowLeft: 'arrow-left',
  ArrowRightFill: 'arrow-right-fill',
  ArrowRightFromBlueDot: 'arrow-right-from-blue-dot',
  ArrowRightFromLine: 'arrow-right-from-line',
  ArrowRight: 'arrow-right',
  ArrowTopRight1: 'arrow-top-right-1',
  ArrowTopRightQuestionFill: 'arrow-top-right-question-fill',
  ArrowTopRightQuestion: 'arrow-top-right-question',
  ArrowTopRight: 'arrow-top-right',
  ArrowTwoCirclepathHorizontal: 'arrow-two-circlepath-horizontal',
  ArrowTwoCirclepathVertical: 'arrow-two-circlepath-vertical',
  ArrowTwoCirclepathVetical: 'arrow-two-circlepath-vetical',
  ArrowTwoRectanglepathHorizontal: 'arrow-two-rectanglepath-horizontal',
  ArrowUpArrowDownSmall: 'arrow-up-arrow-down-small',
  ArrowUpArrowDown: 'arrow-up-arrow-down',
  ArrowUpRight: 'arrow-up-right',
  ArrowUp: 'arrow-up',
  ArrowUpwardTrend: 'arrow-upward-trend',
  AttachFile: 'attach-file',
  BanknoteFill: 'banknote-fill',
  BanknoteTwoFill: 'banknote-two-fill',
  BanknoteTwo: 'banknote-two',
  Banknote: 'banknote',
  BatteryExclamation: 'battery-exclamation',
  Battery: 'battery',
  BazzarpayLogo: 'bazzarpay-logo',
  BellDotFill: 'bell-dot-fill',
  BellFill: 'bell-fill',
  Bell: 'bell',
  BookmarkFill: 'bookmark-fill',
  Bookmark: 'bookmark',
  BoxCheck: 'box-check',
  BoxFill: 'box-fill',
  BoxSlashFill: 'box-slash-fill',
  Box: 'box',
  BriefcaseFill: 'briefcase-fill',
  Briefcase: 'briefcase',
  BuildingFill: 'building-fill',
  Building: 'building',
  CalendarFill: 'calendar-fill',
  Calendar: 'calendar',
  CallDialogBox: 'call-dialog-box',
  CallLeftSlash: 'call-left-slash',
  CallLeft: 'call-left',
  CallRigh: 'call-righ',
  CallRightSlash: 'call-right-slash',
  CallSafeLeft: 'call-safe-left',
  CallSafeRight: 'call-safe-right',
  CameraFill: 'camera-fill',
  CameraPlus: 'camera-plus',
  Camera: 'camera',
  CarClockFill: 'car-clock-fill',
  CarClock: 'car-clock',
  CarFill: 'car-fill',
  CarSlashFill: 'car-slash-fill',
  CarSlash: 'car-slash',
  CarSpark: 'car-spark',
  Car: 'car',
  CardFill: 'card-fill',
  CardLeftArrowFill: 'card-left-arrow-fill',
  CardLeftArrow: 'card-left-arrow',
  CardPlusFill: 'card-plus-fill',
  CardPlus: 'card-plus',
  CardRightArrowFill: 'card-right-arrow-fill',
  CardRightArrow: 'card-right-arrow',
  CardSparkFill: 'card-spark-fill',
  CardSpark: 'card-spark',
  CardTimeFill: 'card-time-fill',
  CardTime: 'card-time',
  Card: 'card',
  CheckBold: 'check-bold',
  CheckFill: 'check-fill',
  CheckVariant: 'check-variant',
  Check: 'check',
  ChevronDownFill: 'chevron-down-fill',
  ChevronDown: 'chevron-down',
  ChevronLeftFill: 'chevron-left-fill',
  ChevronLeft: 'chevron-left',
  ChevronRightFill: 'chevron-right-fill',
  ChevronRight: 'chevron-right',
  ChevronUpFill: 'chevron-up-fill',
  ChevronUp: 'chevron-up',
  CircleCheckFill: 'circle-check-fill',
  CircleCheckSmallFill: 'circle-check-small-fill',
  CircleCheckSmall: 'circle-check-small',
  CircleCheck: 'circle-check',
  CircleCrossFill: 'circle-cross-fill',
  CircleCross: 'circle-cross',
  CircleExclamationFill: 'circle-exclamation-fill',
  CircleExclamation: 'circle-exclamation',
  CircleInformationFill: 'circle-information-fill',
  CircleInformation: 'circle-information',
  CircleMinusFill: 'circle-minus-fill',
  CircleMinus: 'circle-minus',
  CircleMoreFill: 'circle-more-fill',
  CirclePersonFill1: 'circle-person-fill-1',
  CirclePersonFill: 'circle-person-fill',
  CirclePerson: 'circle-person',
  CirclePlusFill: 'circle-plus-fill',
  CirclePlus: 'circle-plus',
  CircleQuestionFill: 'circle-question-fill',
  CircleStarFill: 'circle-star-fill',
  CircleStar: 'circle-star',
  CircleThunderFill: 'circle-thunder-fill',
  CircleThunder: 'circle-thunder',
  ClipboardClockFill: 'clipboard-clock-fill',
  ClipboardClock: 'clipboard-clock',
  ClipsTogether: 'clips-together',
  ClockArrowCirclepath: 'clock-arrow-circlepath',
  ClockArrowCirclepathOrange: 'clock-arrow-circlepath-orange',
  ClockDashed: 'clock-dashed',
  ClockFill: 'clock-fill',
  ClockSmallFill: 'clock-small-fill',
  ClockSmall: 'clock-small',
  Clock: 'clock',
  Co2Circle: 'co2-circle',
  Co2: 'co2',
  CopyFill: 'copy-fill',
  Copy: 'copy',
  CouponFill: 'coupon-fill',
  CouponPuchedFill: 'coupon-puched-fill',
  CouponPuched: 'coupon-puched',
  Coupon: 'coupon',
  CrossBold: 'cross-bold',
  CrossFill: 'cross-fill',
  Cross: 'cross',
  DefaultFill: 'default-fill',
  Default: 'default',
  DeleteLeftFill: 'delete-left-fill',
  DeleteLeft: 'delete-left',
  DialogBoxTextFillLeft: 'dialog-box-text-fill-left',
  DialogBoxTextFill: 'dialog-box-text-fill',
  DialogBoxTextLeftFill: 'dialog-box-text-left-fill',
  DialogBoxTextLeft: 'dialog-box-text-left',
  DialogBoxTextRightFill: 'dialog-box-text-right-fill',
  DialogBoxTextRight: 'dialog-box-text-right',
  DialogBoxText: 'dialog-box-text',
  DialogboxQuestion: 'dialogbox-question',
  DiamondArrowTurnRight1: 'diamond-arrow-turn-right-1',
  DiamondArrowTurnRightFill: 'diamond-arrow-turn-right-fill',
  DiamondArrowTurnRight: 'diamond-arrow-turn-right',
  DotFill: 'dot-fill',
  DoubleCheck: 'double-check',
  EarSlash: 'ear-slash',
  EnvelopeFill: 'envelope-fill',
  EnvelopeOpenFill: 'envelope-open-fill',
  EnvelopeOpen: 'envelope-open',
  Envelope: 'envelope',
  ExclamationBold: 'exclamation-bold',
  ExclamationFill: 'exclamation-fill',
  Exclamation: 'exclamation',
  EyeFill: 'eye-fill',
  EyeSlashFill: 'eye-slash-fill',
  EyeSlashStripes: 'eye-slash-stripes',
  EyeSlash: 'eye-slash',
  Eye: 'eye',
  FaceSadFill: 'face-sad-fill',
  FaceSad: 'face-sad',
  FaceSmileFill: 'face-smile-fill',
  FaceSmile: 'face-smile',
  FactCheck: 'fact_check',
  FactCheckFill: 'fact-check-fill',
  FingerLeftFill: 'finger-left-fill',
  FingerSwipeVertical: 'finger-swipe-vertical',
  FingerTouch: 'finger-touch',
  FingerUpFill: 'finger-up-fill',
  FireFill: 'fire-fill',
  Fire: 'fire',
  FlagFill: 'flag-fill',
  Flag: 'flag',
  GarageLogo: 'garage-logo',
  GasStationFill: 'gas-station-fill',
  GasStation: 'gas-station',
  GearFill: 'gear-fill',
  Gear: 'gear',
  Gift: 'gift',
  Globe: 'globe',
  GraduationCapFill: 'graduation-cap-fill',
  GraduationCap: 'graduation-cap',
  HeadphoneFill: 'headphone-fill',
  Headphone: 'headphone',
  HeartBrokenFill: 'heart-broken-fill',
  HeartFill: 'heart-fill',
  Heart: 'heart',
  HelmetsFillRtl: 'helmets-fill-rtl',
  HelmetsFill: 'helmets-fill',
  HelmetsRtl: 'helmets-rtl',
  Helmets: 'helmets',
  HomeFill: 'home-fill',
  Home: 'home',
  HourglassFill: 'hourglass-fill',
  Hourglass: 'hourglass',
  ImageFill: 'image-fill',
  ImageTwoFill: 'image-two-fill',
  ImageTwo: 'image-two',
  Image: 'image',
  InfoBold: 'info-bold',
  InfoFill: 'info-fill',
  Info: 'info',
  InstagramLogoFill: 'instagram-logo-fill',
  InstagramLogo: 'instagram-logo',
  KeyboardFill: 'keyboard-fill',
  Keyboard: 'keyboard',
  LampSparkFill: 'lamp-spark-fill',
  Language: 'Language',
  LeafFill: 'leaf-fill',
  Leaf: 'leaf',
  LicenseFill: 'License-fill',
  License: 'License',
  LightningBolt: 'lightning-bolt',
  LineThreeHorizontalDecrease: 'line-three-horizontal-decrease',
  LineThree: 'line-three',
  ListBullet: 'list-bullet',
  LoadingSpinner: 'loading-spinner',
  Loading: 'loading',
  LocationLeft: 'location-left',
  LocationTopRightFill: 'location-top-right-fill',
  LocationTopRightQuestionFill: 'location-top-right-question-fill',
  LocationTopRightQuestion: 'location-top-right-question',
  LocationTopRight: 'location-top-right',
  LocationUp: 'location-up',
  LockFill: 'lock-fill',
  LockSmallFill: 'lock-small-fill',
  LockSmall: 'lock-small',
  Lock: 'lock',
  LuggageFill: 'luggage-fill',
  Luggage: 'luggage',
  MagnifierFill: 'magnifier-fill',
  Magnifier: 'magnifier',
  MapFill: 'map-fill',
  Map: 'map',
  Medal1: 'medal-1',
  MedalFill1: 'medal-fill-1',
  MedalFill: 'medal-fill',
  MedalVariantFill: 'medal-variant-fill',
  MedalVariant: 'medal-variant',
  Medal: 'medal',
  MicrophoneFill: 'microphone-fill',
  MicrophoneSlashFill: 'microphone-slash-fill',
  MicrophoneSlash: 'microphone-slash',
  MicrophoneSparkFill: 'microphone-spark-fill',
  MicrophoneSpark: 'microphone-spark',
  Microphone: 'microphone',
  MinusBold: 'minus-bold',
  MinusFill: 'minus-fill',
  Minus: 'minus',
  MoonFill: 'moon-fill',
  Moon: 'moon',
  MoreHorizontalBold: 'more-horizontal-bold',
  MoreHorizontalFill: 'more-horizontal-fill',
  MoreHorizontal: 'more-horizontal',
  MoreVerticalBold: 'more-vertical-bold',
  MoreVerticalFill: 'more-vertical-fill',
  MoreVertical: 'more-vertical',
  Motorcycle: 'motorcycle',
  PauseCircleFill: 'pause-circle-fill',
  PauseCircle: 'pause-circle',
  Pause: 'pause',
  PencilLineFill: 'pencil-line-fill',
  PencilLine: 'pencil-line',
  Person1: 'person-1',
  PersonFill1: 'person-fill-1',
  PersonFill: 'person-fill',
  PersonInWheelchair: 'person-in-wheelchair',
  PersonMinusFill: 'person-minus-fill',
  PersonMinus: 'person-minus',
  PersonPlusFill: 'person-plus-fill',
  PersonPlus: 'person-plus',
  PersonTwoFill: 'person-two-fill',
  PersonTwo: 'person-two',
  PersonVariantFill: 'person-variant-fill',
  PersonVariant: 'person-variant',
  PersonWaveFill: 'person-wave-fill',
  PersonWave: 'person-wave',
  Person: 'person',
  PhoneFill: 'phone-fill',
  PhoneVibrateFill: 'phone-vibrate-fill',
  PhoneVibrate: 'phone-vibrate',
  Phone: 'phone',
  PinCircleFill: 'pin-circle-fill',
  PinCircle: 'pin-circle',
  PinCrossFill: 'pin-cross-fill',
  PinCross: 'pin-cross',
  PinFill: 'pin-fill',
  PinOnMapFill: 'pin-on-map-fill',
  PinOnMap: 'pin-on-map',
  PinWaveFill: 'pin-wave-fill',
  PinWave: 'pin-wave',
  PlaneFill: 'plane-fill',
  Plane: 'plane',
  PlanetEarth: 'planet-earth',
  PlayCircleFill: 'play-circle-fill',
  PlayCircle: 'play-circle',
  Play: 'play',
  PlusBold: 'plus-bold',
  PlusFill: 'plus-fill',
  Plus: 'plus',
  PointThreeConnectedLineFill: 'point-three-connected-line-fill',
  PointThreeConnectedLine: 'point-three-connected-line',
  PointThreeConnectedTrianglepathLineFill:
    'point-three-connected-trianglepath-line-fill',
  PointThreeConnectedTrianglepathLine:
    'point-three-connected-trianglepath-line',
  PollutionZone: 'pollution-zone',
  Power: 'power',
  PushpinFill: 'Pushpin-fill',
  Question: 'question',
  RatioHorizontalFill: 'ratio-horizontal-fill',
  RatioHorizontal: 'ratio-horizontal',
  RatioSquareFill: 'ratio-square-fill',
  RatioSquare: 'ratio-square',
  RatioVerticalFill: 'ratio-vertical-fill',
  RatioVertical: 'ratio-vertical',
  Record: 'record',
  RectanglePersonTextWithBadge: 'rectangle-person-text-with-badge',
  ScanFill: 'scan-fill',
  Scan: 'scan',
  SendChatFill: 'send-chat-fill',
  SendChat: 'send-chat',
  ShareFill: 'share-fill',
  Share: 'share',
  Shield1: 'shield-1',
  ShieldCheckFill: 'shield-check-fill',
  ShieldCheck: 'shield-check',
  ShieldFill: 'shield-fill',
  Shield: 'shield',
  ShoppingBagFill: 'shopping-bag-fill',
  ShoppingBag: 'shopping-bag',
  ShoppingCartFillLtr: 'shopping-cart-fill-ltr',
  ShoppingCartFill: 'shopping-cart-fill',
  ShoppingCartLtr: 'shopping-cart-ltr',
  ShoppingCart: 'shopping-cart',
  Silence: 'silence',
  SingleCheck: 'single-check',
  SirenFill: 'siren-fill',
  Siren: 'siren',
  SliderHorizontalFill: 'slider-horizontal-fill',
  SliderHorizontal: 'slider-horizontal',
  SparkFill: 'spark-fill',
  SparkSmallFill: 'spark-small-fill',
  SparkSmall: 'spark-small',
  SparkThreeFill: 'spark-three-fill',
  SparkThree: 'spark-three',
  Spark: 'spark',
  SpeakerCross: 'speaker-cross',
  SpeakerExclamation: 'speaker-exclamation',
  SpeakerWave: 'speaker-wave',
  SpiralDotTwo: 'spiral-dot-two',
  SquareCategoryFill: 'square- category-fill',
  SquareAboveSquares: 'square-above-squares',
  SquareCategory: 'square-category',
  SquareFill: 'square-fill',
  SquareFourFill: 'square-four-fill',
  SquareFour: 'square-four',
  SquareGridFill: 'square-grid-fill',
  SquareGridRoundedFill: 'square-grid-rounded-fill',
  SquareGridRounded: 'square-grid-rounded',
  SquareGrid: 'square-grid',
  SquareMoreFill: 'square-more-fill',
  SquareMore: 'square-more',
  SquarePersonFill: 'square-person-fill',
  SquarePerson: 'square-person',
  StarFill: 'star-fill',
  Star: 'star',
  SteerFill: 'steer-fill',
  Steer: 'steer',
  StickyNoteFill: 'sticky-note-fill',
  StickyNote: 'sticky-note',
  StoreFill: 'store-fill',
  Store: 'store',
  SunFill: 'sun-fill',
  Sun: 'sun',
  TapsiLogo: 'tapsi-logo',
  TaraLogo: 'tara-logo',
  TargetFill: 'target-fill',
  TargetSlash: 'target-slash',
  Target: 'target',
  TelegramLogoFill: 'Telegram-logo-fill',
  TelephoneFill: 'telephone-fill',
  Telephone: 'telephone',
  ThumbDownFill: 'thumb-down-fill',
  ThumbDown: 'thumb-down',
  ThumbUpFill: 'thumb-up-fill',
  ThumbUp: 'thumb-up',
  Thunder: 'thunder',
  TimerFill: 'timer-fill',
  Timer: 'timer',
  TrafficControlZoneFill: 'traffic-control-zone-fill',
  TrafficLightFill: 'traffic-light-fill',
  TrafficLight: 'traffic-light',
  TrashFill: 'trash-fill',
  Trash: 'trash',
  TriangleExclamationFill: 'triangle-exclamation-fill',
  TriangleExclamation: 'triangle-exclamation',
  TrophyFill: 'trophy-fill',
  Trophy: 'trophy',
  UfoFill: 'ufo-fill',
  Ufo: 'ufo',
  UnlockFill: 'Unlock-fill',
  UnlockSmallFill: 'Unlock-small-Fill',
  UnlockSmall: 'Unlock-small',
  Unlock: 'Unlock',
  VideoTwoFill: 'video-two-fill',
  VideoTwo: 'video-two',
  WalletFill: 'wallet-fill',
  WalletSwap: 'wallet-swap',
  Wallet: 'wallet',
  WifiSlash: 'wifi-slash',
  Wifi: 'wifi',
  WarningFill: 'warning-fill',
  Warning: 'warning',
  Conversation: 'conversation',
  ArchiveFill: 'archive-fill',
  Schedule: 'schedule',
  Badge: 'badge',
  EmptyLeading: 'empty-leading',
  PhoneOndemand: 'phone-ondemand',
  PhoneScheduled: 'phone-scheduled',
  DialogBoxTextLeftFillRound: 'dialog-box-text-left-fill-round',
  HomeHealth: 'home-health',
  Stethoscope: 'stethoscope',
};
export type IconName = keyof typeof ICON_MAP;
export interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: keyof typeof ICON_MAP;
  size?: number;
  width?: number | string;
  height?: number | string;
  className?: string;
  style?: CSSProperties;
  fill?: string;
  stroke?: string;
  onClick?: () => void;
}

const loadIcon = (
  name: keyof typeof ICON_MAP | string,
  width: number | string,
  height: number | string,
) => {
  const fileName = ICON_MAP[name as keyof typeof ICON_MAP];
  if (!fileName) {
    console.warn(`Icon not found: ${name}`);
    return () => (
      <div
        style={{ width: `${width}rem`, height: `${height}rem` }}
        aria-hidden="true"
      />
    );
  }
  return dynamic(() => import(`public/images/icons/${fileName}.svg`), {
    ssr: false,
    loading: () => (
      <div
        style={{ width: `${width}rem`, height: `${height}rem` }}
        aria-hidden="true"
      />
    ),
  }) as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
};

const Icon: React.FC<IconProps> = memo(
  ({
    name,
    width = 1,
    height = 1,
    className,
    style,
    fill,
    stroke,
    onClick,
    viewBox = '0 0 24 24',
    ...props
  }) => {
    const IconComponent = loadIcon(name, width, height);

    return (
      <IconComponent
        width={`${width}rem`}
        height={`${height}rem`}
        className={className}
        style={style}
        fill={fill}
        stroke={stroke}
        onClick={onClick}
        viewBox={viewBox}
        {...(props as React.SVGProps<SVGSVGElement>)}
      />
    );
  },
);

export default memo(Icon);
